import React, { FC } from 'react';
import clsx from 'clsx';

import { NotificationCardProps } from '@types';
import { formatISODate } from '@utils/date';

import Chip from '../chip/Chip';
import Icon from '../icon/Icon';
import Avatar from '../avatar/Avatar';
import { IconButton } from '../button/Button';

const NotificationCard: FC<NotificationCardProps> = (props) => {
  const { handleCardClick, notification, onDelete } = props;
  const isUnread = !notification?.isRead || false;

  const handleDelete = (e: any) => {
    onDelete?.(notification);
    e.stopPropagation();
  };

  return (
    <div
      onClick={handleCardClick}
      role="presentation"
      className={`${
        isUnread ? 'border-primary5' : 'border-primary1'
      } mt-4 cursor-pointer rounded-3xl border bg-white/70 p-4 tablet:py-6 desktop:py-6`}
    >
      <div className="flex grow items-center gap-4 mobile:items-start tablet:flex-row desktop:flex-row">
        <div className="flex items-center gap-4">
          <span
            className={clsx(
              'size-2.5 rounded-full bg-primary5',
              isUnread ? 'opacity-100' : 'opacity-0'
            )}
          />
          <Avatar
            name={notification?.additionalData?.userName || 'Tara'}
            className="size-9 min-h-6 min-w-6 rounded-lg text-sm  text-white lg:size-12 tablet:size-12 tablet:min-w-12 desktop:min-w-12"
          />
        </div>
        <div className="flex min-w-0 grow items-center gap-4 mobile:flex-col mobile:items-start">
          <div className="flex min-w-0 grow items-center">
            <div className="min-w-0 grow">
              <p className="truncate text-base font-semibold leading-6 text-grey10">
                {notification?.message?.header}
              </p>
              <p className="truncate text-base leading-6 text-grey8 mobile:text-sm">
                {notification?.message?.body}
              </p>
            </div>
            {onDelete && (
              <IconButton
                className="ms-auto hidden flex-none !p-2 text-grey mobile:block"
                iconName="trash"
                handleClick={handleDelete}
                variant="transparent"
              />
            )}
          </div>
          <div className="flex items-center gap-3">
            {notification?.additionalData?.type && (
              <Chip
                isCloseIconRequired={false}
                label={notification?.additionalData?.type}
                className="justify-center bg-yellow75 px-2 text-yellow700"
                isTruncate={false}
              />
            )}
            <div className="mx-2 flex flex-col gap-1 whitespace-nowrap text-sm text-grey8">
              <p className="flex items-center gap-1">
                <Icon name="calendar" stroke="#8F95B2" />
                <span>
                  {formatISODate({
                    date: notification?.createdAt,
                    format: 'DD MMM YYYY'
                  })}
                </span>
              </p>

              <p className="flex items-center gap-1">
                <Icon name="clock" />
                <span>
                  {formatISODate({
                    date: notification?.createdAt,
                    format: 'hh:mm'
                  })}
                </span>
              </p>
            </div>
            {onDelete && (
              <IconButton
                className="flex-none !p-2 text-grey duration-200 mobile:hidden"
                iconName="trash"
                handleClick={handleDelete}
                variant="transparent"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationCard;
